var _g, _path, _path2, _path3, _path4, _g2, _g3, _path5, _path6, _g4, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacadeTotalLookDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 398,
    viewBox: "0 0 321 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_172:2393)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 183.5,
    cy: 194.5,
    r: 25.5,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.5,
    cy: 194.5,
    r: 24.75,
    stroke: "white",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.491 234.75L271.169 396.608H210.823L225.792 234.75H296.491Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.71 370.042L299.206 234.75H302.755L320.04 396.608H288.035L279.71 370.042Z",
    stroke: "white",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_172:2393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 210,
    y: 234,
    width: 111,
    height: 164
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.108 234L210 397.358H271.811L297.368 234H225.108Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M303.429 234H298.557L278.943 370.103L287.484 397.358H320.874L303.429 234Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_172:2393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.619 226.772C214.201 238.066 233.366 266.106 233.366 287.922C233.366 309.737 202.526 283.129 187.106 267.098",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.172 437.836C243.487 394.467 225.416 338.086 231.922 316.402C238.427 294.717 244.21 385.793 205.177 327.244",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.528 429.216C301.528 406.085 302.973 362.282 308.756 372.113C315.984 384.401 319.598 426.324 330.441 429.216",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.97,
    cy: 377.842,
    r: 5.75541,
    stroke: "#F7F7F7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.991 410.519C267.057 401.009 343.726 275.924 278.944 369.509M294.991 228.651C268.245 228.651 265.033 279.604 256.359 295.217C245.516 314.733 232.393 246.143 246.849 217.953",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.792 405.764C243.877 351.68 286.076 329.095 267.057 311.265C245.957 291.484 252.792 364.161 322.275 275.202",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_172:2393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3352 9.00049H44.5196L0 54.7073L26.351 76.2042L49.9507 61.587L36.6771 159.061H142.769L134.074 116.863L64.3352 9.00049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.369 9H109.527L87.333 37.8277L131.521 106.421L123.938 61.5865L147.538 76.2037L173.889 54.7069L129.369 9Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_172:2393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 174,
    height: 151
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3352 9.00049H44.5196L0 54.7073L26.351 76.2042L49.9507 61.587L36.6771 159.061H142.769L134.074 116.863L64.3352 9.00049Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.369 9H109.527L87.333 37.8277L131.521 104.076L123.938 61.5865L147.538 76.2037L173.889 54.7069L129.369 9Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_172:2393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2356 -4.85449C23.923 12.0015 8.96039 58.7366 15.6104 110.829",
    stroke: "#E3BC97",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7059 -4.85449C37.7788 3.68898 26.0026 34.2146 34.3152 87.9691C44.7059 155.162 -3.09161 163.475 -6.55518 167.631",
    stroke: "#E3BC97",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1732 -4.16162C50.4769 2.99642 41.1022 27.149 57.1732 66.4952C77.2619 115.678 64.1001 173.866 50.9385 185.642",
    stroke: "#E3BC97",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7209 -3.46875C64.332 5.76743 56.0656 32.4138 82.1116 65.1099C114.669 105.98 114.669 147.543 111.898 174.559",
    stroke: "#E3BC97",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1256 -0.431641C92.4311 12.499 91.4151 39.7457 116.907 45.2875C148.772 52.2146 174.402 50.1365 184.793 82.694",
    stroke: "#E3BC97",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2147 -5.81348C98.0602 8.0408 106.419 34.9181 149.09 31.5931",
    stroke: "#E3BC97",
    strokeWidth: 1.5
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.164 19.731L196.153 10.429C198.362 8.14344 198.687 4.3833 196.597 1.98132C196.074 1.37793 195.437 0.891245 194.726 0.550968C194.014 0.210692 193.243 0.0239566 192.46 0.0021574C191.677 -0.0196418 190.897 0.123952 190.169 0.424177C189.441 0.724402 188.78 1.17496 188.226 1.74837L186.537 3.49672L185.078 1.98719C182.869 -0.298402 179.236 -0.635605 176.915 1.52734C176.332 2.06912 175.861 2.72816 175.532 3.46425C175.204 4.20034 175.023 4.99804 175.002 5.80868C174.981 6.61932 175.12 7.4259 175.41 8.17921C175.7 8.93252 176.135 9.61677 176.69 10.1902L185.909 19.731C186.076 19.9032 186.301 20 186.537 20C186.772 20 186.998 19.9032 187.164 19.731Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_172:2393",
    x: 154,
    y: 165,
    width: 59,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_172:2393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_172:2393",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_172:2393",
    x: -4,
    y: 5,
    width: 181.889,
    height: 158.061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_172:2393"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_172:2393",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacadeTotalLookDesktop);
export default __webpack_public_path__ + "static/media/facade-total-look-desktop.1bc413b3.svg";
export { ForwardRef as ReactComponent };